import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const resetWindowScroll = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  if (document.body) {
    document.body.scrollTop = 0;
  }
};

/** Accordion open state in the query string — must not reset scroll. */
const stripAccordionSearch = (search) => {
  const params = new URLSearchParams(search || "");
  params.delete("expanded");
  return params.toString();
};

/**
 * Scroll the page to the top on route changes (list → view/edit, etc.).
 */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  const scrollKey = useMemo(
    () => `${pathname}?${stripAccordionSearch(search)}${hash}`,
    [pathname, search, hash]
  );

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    resetWindowScroll();
  }, [scrollKey]);

  return null;
};

export default ScrollToTop;
